// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".meeting-canceled-tips[data-v-0bea7f72]{display:flex;flex-direction:column;align-items:center}.meeting-canceled-tips>img[data-v-0bea7f72]{margin-top:47px}.meeting-canceled-tips .meeting-status[data-v-0bea7f72]{font-size:18px;line-height:26px;color:#f1b634;margin:12px 0}.meeting-canceled-tips .meeting-tips[data-v-0bea7f72]{font-size:14px;line-height:22px;color:rgba(0,0,0,.45)}", ""]);
// Exports
module.exports = exports;
